export const NoteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#50AFD8"
      d="M15.833 2.5H4.158c-.916 0-1.658.75-1.658 1.667l.008 11.666c0 .917.742 1.667 1.659 1.667H12.5l5-5V4.167c0-.917-.75-1.667-1.667-1.667M6.667 6.667h6.666c.459 0 .834.375.834.833a.836.836 0 0 1-.834.833H6.667a.836.836 0 0 1-.834-.833c0-.458.375-.833.834-.833m2.5 5h-2.5a.836.836 0 0 1-.834-.834c0-.458.375-.833.834-.833h2.5c.458 0 .833.375.833.833a.836.836 0 0 1-.833.834m2.5 4.583V12.5c0-.458.375-.833.833-.833h3.75z"
    ></path>
  </svg>
);